import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem, Label } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME } from "src/constant/common";
import { useTranslation } from "react-i18next";
import { PATTERN_NUMBER } from "src/constant/common";

const MCSMission = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <AccordionItem>
      <AccordionHeader targetId="7" className="mt-0 fw-bold">
        {t("new.MCS.mission_criterias")}
      </AccordionHeader>
      <AccordionBody accordionId="7">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.ALTITUDE_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m)`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m/s)`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m/s)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(m/s)`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.ROLL_ANGLE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.ROLL_ANGLE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.ROLL_ANGLE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.PITCH_ANGLE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.PITCH_ANGLE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.PITCH_ANGLE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg)`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.YAW_ANGLE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.YAW_ANGLE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.YAW_ANGLE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.ROLL_RATE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.ROLL_RATE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.ROLL_RATE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg/s)`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.PITCH_RATE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.PITCH_RATE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.PITCH_RATE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg/s)`}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group position-relative">
              <Label for={`MCS.${FORM_NAME.MCS.YAW_RATE}`} className="position-relative required-input">
                {t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`)}
              </Label>
              <div className="d-flex align-items-center ms-2">
                <span className="text-nowrap me-1">{t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}_text`)}</span>
                <FormInput
                  register={register}
                  name={`MCS.${FORM_NAME.MCS.YAW_RATE}`}
                  placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`) })}
                  classInput="w-100"
                  classGroup="mb-0 w-100"
                  errors={errors?.MCS?.[FORM_NAME.MCS.YAW_RATE]?.message}
                  requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`) })}
                  required
                  pattern={{
                    value: PATTERN_NUMBER,
                    message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`) }),
                  }}
                  maxLength={255}
                  maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`) })}
                />
                <span className="ms-1 min-width-by-px-56 width-by-px-56">{`(deg/s)`}</span>
              </div>
            </div>
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default MCSMission;
